var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h2',{staticClass:"font-weight-bold d-flex justify-space-between",class:{
      'text--secondary text-h6 text-uppercase': _vm.secondary,
      'text-h4 mt-2 mb-4': !_vm.secondary,
    }},[_c('div',[_vm._t("default")],2),_c('div',[_vm._t("right")],2)]),(!_vm.borderless)?_c('v-divider',{staticClass:"my-2"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }